import React from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';

import PrivateRoute from './PrivateRoute';
import NotFoundPage from '../views/404';
import Mind from '../views/Mind';
import EspaceClient from '../views/EspaceClient';
import CommunautePage from '../communaute/CommunautePage';
import MessagerieRoute from '../communaute/MessagerieRoute';
import NotificationsPage from '../communaute/NotificationsPage';

import Profil from '../components/Profil';
import Dashboard from '../components/Dashboard';
import CGUPage from "../views/CGUPage";
import ContactPage from '../views/ContactPage';
import SupprimerComptePage from '../views/SupprimerComptePage';
import SignalerProblemePage from '../views/SignalerProblemePage';
import DevenirPartenairePage from '../views/DevenirPartenairePage';
import PolitiqueConfidentialite from '../views/PolitiqueConfidentialite';
import MesEvents from '../components/MesEvents';
//import AddEvent from '../components/AddEvent';
import ViewEvent from '../components/ViewEvent';
//import UpdateEvent from '../components/UpdateEvent';
import ChangePasswordPage from '../components/ChangePasswordPage';
import AdminTickets from '../components/AdminTickets';
import AdminLayout from '../components/admin/AdminLayout';
import AdminAccueil from '../components/admin/AdminAccueil';
import AdminUtilisateurs from '../components/admin/AdminUtilisateurs';
import AdminCreateurs from '../components/admin/AdminCreateurs';
import AdminEvenements from '../components/admin/AdminEvenements';
import AdminReservations from '../components/admin/AdminReservations';
import AdminFinances from '../components/admin/AdminFinances';
import AdminVersements from '../components/admin/AdminVersements';
import AdminDemandes from '../components/admin/AdminDemandes';
import AdminAnnulations from '../components/admin/AdminAnnulations';
import LoginAdmin from '../components/Loginadmin';
import PublicEvent from '../views/PublicEvent';
import MonAgenda from '../components/MonAgenda';
import MentionsLegales from '../views/MentionsLegales';
import MaBilletterie from '../components/MaBilletterie';
//import Abonnement from '../components/Abonnement';
import AddEvent2 from '../components/AddEvent2';
import UpdateEvent2 from '../components/UpdateEvent2';
import MonEquipe from '../components/MonEquipe';
import MindHome from '../views/MindHome';
import StripeRetour from '../components/StripeRetour';
import DonMerci from '../components/DonMerci';
import ConsultantDashboard, { ConsultantCadre, ConsultantRoute } from '../views/ConsultantDashboard';
import ConsultantLogin from '../views/ConsultantLogin';
import AdminConsultants from '../components/admin/AdminConsultants';
//import ListeEvenements from '../views/ListeEvenements';   // 🆕 à créer
//import AgendaPage from '../views/AgendaPage';   // 🆕 à créer
//import CartePage from '../views/CartePage';

const AppRouter = () => (
  <Router basename="/">
    <Routes>

      {/* ══════════════════════════════════════
          PUBLIC — indexable par Google
      ═══════════════════════════════════════ */}
      <Route path="/" element={<MindHome />} />
      {/*<Route path="/pourquoi" element={<Mind />} />*/}
      {/*
      <Route path="/carte" element={<CartePage />} />
       📅 Agenda 
      <Route path="/agenda" element={<AgendaPage />} />
      {/* Détail d'un événement */}
      <Route path="/evenement/:id" element={<PublicEvent />} />
      <Route path="/mentions-legales" element={<MentionsLegales />} />   {/* 🆕 */}
      <Route path="/devenir-partenaire" element={<DevenirPartenairePage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/signaler-probleme" element={<SignalerProblemePage />} />
      <Route path="/supprimer-compte" element={<SupprimerComptePage />} />
      <Route path="/don/merci" element={<DonMerci />} />
      {/* ══════════════════════════════════════
          LÉGAL
          ⚠️ /cgu redirige : évite le contenu dupliqué
      ═══════════════════════════════════════ */}
      <Route path="/conditions-generales" element={<CGUPage />} />
      <Route path="/cgu" element={<Navigate to="/conditions-generales" replace />} />
      <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />

      {/* ══════════════════════════════════════
          AUTHENTIFICATION
      ═══════════════════════════════════════ */}
      <Route path="/admin/login" element={<LoginAdmin />} />
      <Route path="/changerpassword/:token" element={<ChangePasswordPage />} />

      {/* ══════════════════════════════════════
          ESPACE CLIENT (privé)
      ═══════════════════════════════════════ */}
      <Route
        path="/EspaceClient/*"
        element={
          <PrivateRoute redirectPath="/">
            <EspaceClient />
          </PrivateRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="profil" element={<Profil />} />
        <Route path="communaute" element={<CommunautePage />} />
        <Route path="communaute/publications" element={<CommunautePage />} />
        <Route path="messagerie" element={<MessagerieRoute />} />
        <Route path="notifications" element={<NotificationsPage />} />
        <Route path="agenda" element={<MonAgenda />} />
        {/*<Route path="abonnement" element={<Abonnement />} />*/}
        <Route path="mabilletterie" element={<MaBilletterie />} />

        <Route path="stripe/retour" element={<StripeRetour mode="retour" />} />
        <Route path="stripe/refresh" element={<StripeRetour mode="refresh" />} />
        <Route path="monequipes" element={<MonEquipe />} />
        <Route path="mesevents" element={<MesEvents />} />
        <Route path="mesevents/ajouter" element={<AddEvent2 />} />
        <Route path="mesevents/view/:id" element={<ViewEvent />} />
        <Route path="mesevents/update/:id" element={<UpdateEvent2 />} />
      </Route>

      {/* ══════════════════════════════════════
          CONSULTANT — espace SÉPARÉ du créateur
          Connexion : /consultant/login  (API login/consultant)
          (l'admin y accède aussi via "Publier pour un créateur")
      ═══════════════════════════════════════ */}
      <Route path="/consultant/login" element={<ConsultantLogin />} />
      <Route path="/consultant" element={<ConsultantRoute><ConsultantDashboard /></ConsultantRoute>} />
      <Route path="/consultant/ajouter" element={<ConsultantRoute><ConsultantCadre><AddEvent2 /></ConsultantCadre></ConsultantRoute>} />
      <Route path="/consultant/modifier/:id" element={<ConsultantRoute><ConsultantCadre><UpdateEvent2 /></ConsultantCadre></ConsultantRoute>} />

      {/* ══════════════════════════════════════
          ADMIN (privé)
      ═══════════════════════════════════════ */}
      <Route
        path="/admin/*"
        element={
          <PrivateRoute redirectPath="/admin/login">
            <AdminLayout />
          </PrivateRoute>
        }
      >
        <Route index element={<AdminAccueil />} />
        <Route path="utilisateurs" element={<AdminUtilisateurs />} />
        <Route path="createurs" element={<AdminCreateurs />} />
        <Route path="evenements" element={<AdminEvenements />} />
        <Route path="evenements/ajouter" element={<AddEvent2 />} />
        <Route path="evenements/update/:id" element={<UpdateEvent2 />} />
        <Route path="reservations" element={<AdminReservations />} />
        <Route path="finances" element={<AdminFinances />} />
        <Route path="versements" element={<AdminVersements />} />
        <Route path="demandes" element={<AdminDemandes />} />
        <Route path="annulations" element={<AdminAnnulations />} />
        <Route path="tickets" element={<AdminTickets />} />
        <Route path="consultants" element={<AdminConsultants />} />
      </Route>

      {/* ══════════════════════════════════════
          404 — TOUJOURS EN DERNIER
      ═══════════════════════════════════════ */}
      <Route path="*" element={<NotFoundPage />} />

    </Routes>
  </Router>
);

export default AppRouter;